module.exports = __webpack_public_path__ + "static/media/app-baner-btn.2fd4cb89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app-baner-btn.png
// module id = 78
// module chunks = 0